{
  "name": "19-tone partial sequence (32°-52°) (Odd Partials)",
  "description": "A cycle of harmonic partials (32° 33°) 34° to 51° (52°), repeating at the perfect fifth over changing fundamentals. Partial 48° is reinterpreted as 32° (and 51° = 34°); the fundamental shifts up a perfect fifth. Matching partial numbers produce perfect fifths instead of octaves. Useful for investigating possible chords of higher partials embedded within a perfect fifth, for example 6:7:8:9, 8:9:11:12, 10:12:13:15, and others. The 48° of the central transposition of the scale is set to 440 Hz.",
  "scale": [
    "52/51",
    "35/34",
    "36/34",
    "37/34",
    "38/34",
    "39/34",
    "40/34",
    "41/34",
    "42/34",
    "43/34",
    "44/34",
    "45/34",
    "46/34",
    "47/34",
    "48/34",
    "49/34",
    "99/68",
    "50/34",
    "51/34"
  ],
  "key_colors_mode": "manual",
  "short_description": "19-HS_34to52-Odd",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "51|17",
    "13|",
    "|35",
    "9",
    "37",
    "19",
    "39",
    "5",
    "41",
    "21",
    "43",
    "11",
    "45",
    "23",
    "47",
    "3|1",
    "49|",
    "|33",
    "25|"
  ],
  "note_colors": [
    "#ff8989",
    "#e6d7fe",
    "#ffcba8",
    "#ffffff",
    "#cee3e2",
    "#d6f7ff",
    "#e6d7fe",
    "#fffae5",
    "#f89b87",
    "#ffe5e5",
    "#c9a573",
    "#dfffd6",
    "#fffae5",
    "#95c69b",
    "#ffb8da",
    "#ffffff",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be"
  ],
  "equivSteps": 19,
  "fundamental": 440,
  "reference_degree": 15,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 3,
  "hexSize": 36,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
